import styled from '@emotion/styled';
import { Breadcrumb, Divider, Image, Space } from 'antd';
import { FaHome } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../../routes';
import { ORANGE, YELLOW } from '../../../shared/colors';
import { Footer } from '../../homePage/components/Footer';
import { Layout } from '../../shared/Layout';
import { Bourse } from '../components/Bourse';

const Container = styled.div`
  // height: calc(100vh - 32px);
  background-color: white;

  .banner {
    min-height: 300px;
    background-image: url('assets/images/actualite.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    > .black-background {
      padding: 5% 15% 5% 15%;
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      min-height: 300px;
    }

    .banner-head {
      align-items: center;
    }

    .banner-logo,
    .banner-logo .ant-image-img {
      width: 130px;
    }

    .brand-title {
      font-family: Poppins-B;
      font-size: clamp(27px, 4vw, 35px);
      line-height: 1.1;
    }

    .page-title {
      color: white;
      font-family: Poppins-B;
      font-size: clamp(24px, 3.2vw, 30px);
      line-height: 1.15;
    }

    .bread-crumb {
      font-size: 14px;
      margin-top: 10px;

      span {
        color: white;
        font-family: Poppins-L;
      }
    }

    .menus {
      display: flex;
      overflow-x: auto;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }

      > p {
        color: white;
        flex: 0 0 auto;
        text-transform: uppercase;
        font-family: Poppins-L;
        font-size: 17px;
        padding: 12px 10px;
        margin-right: 15px;

        &:hover {
          background-color: ${YELLOW};
          cursor: pointer;
        }
      }
    }
  }

  > .content {
    min-height: 400px;
    background-color: white;
    color: black;
    padding: 2% 15%;

    > h2 {
      font-family: Poppins-B;
      font-size: 25px;
      margin-bottom: 15px;
      color: ${YELLOW};
    }

    > div {
      display: flex;
      flex-wrap: wrap;
    }
  }

  @media (max-width: 767px) {
    .banner {
      min-height: 292px;

      > .black-background {
        min-height: 292px;
        padding: 28px 24px 22px;
      }

      .banner-head {
        display: flex;
      }

      .banner-logo,
      .banner-logo .ant-image-img {
        width: 90px;
      }

      .bread-crumb {
        margin-top: 16px;
      }
    }

    > .content {
      padding: 30px 24px;
    }
  }
`;

export const BoursePage = () => {
  const history = useHistory();
  // const [option, setOption] = useState('1');

  return (
    <Layout>
      <Container>
        <div className='banner'>
          <div className='black-background'>
            <Space size={10} className='banner-head'>
              <Image
                alt='moranje-logo'
                className='banner-logo'
                src='assets/images/moranje-logo.png'
                width={130}
                preview={false}
                style={{ objectFit: 'contain' }}
              />
              <div>
                <div className='brand-title'>
                  <span style={{ color: ORANGE }}>Moranj</span>
                  <span style={{ color: '#6d4c41' }}>E</span>
                  <span style={{ color: YELLOW }}>trade</span>
                </div>
                <div className='page-title'>Réseau</div>
              </div>
            </Space>
            <Breadcrumb separator='>' className='bread-crumb'>
              <Breadcrumb.Item onClick={() => history.push(ROUTES.HOME_PAGE)}>
                <span style={{ cursor: 'pointer' }}>
                  <FaHome style={{ marginRight: 5 }} />
                  <span>Accueil</span>
                </span>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <span>Réseau</span>
              </Breadcrumb.Item>
            </Breadcrumb>
            <Divider style={{ backgroundColor: 'white', marginBottom: 0 }} />

            <div className='menus'>
              {/*   {RESEAU.map((res, i) => (
                <p key={i} onClick={() => {}}>
                  {res.label}
                </p>
              ))} */}
            </div>
          </div>
        </div>

        <div className='content'>
          <h2>Liste des sociétés agrées</h2>
          <Divider style={{ backgroundColor: 'orange', marginBottom: 10 }} />
          <Bourse />
        </div>

        <div style={{ backgroundColor: 'white' }}>
          <Footer />
        </div>
      </Container>
    </Layout>
  );
};

// const RESEAU = [
//   {
//     label: 'Société de bourses',
//     option: '1',
//   },
//   {
//     label: 'Réseau',
//     option: '2',
//   },
//   {
//     label: 'Membres',
//     option: '3',
//   },
//   {
//     label: 'Banques',
//     option: '4',
//   },
// ];
